
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class vSelect2 extends Vue {
  @Prop() value: any;
  @Prop() options: any;

  element: any;

  @Watch("value")
  onValueChanged(val: any) {
    (<any>$(this.element)).val(val).trigger("change");
  }

  @Watch("options")
  onOptionsChanged(val: any) {
    (<any>$(this.element)).empty().select2({ data: val });
  }

  mounted() {
    this.element = this.$refs["select2"];

    (<any>$(this.element))
      .select2(this.options ? { data: this.options } : {})
      .val(this.value)
      .trigger("change")
      .on("select2:select", (eventData: any) => {
        let id = parseInt(eventData.target.value);
        this.$emit("input", id);
      });
  }

  destroyed() {
    (<any>$(this.element)).off().select2("destroy");
  }
}
